import { createContext, useContext } from "react";
import { Client } from "creso-core/types";

export type ClientOnboardingContextValue = {
  client: Client | null;
  close: () => void;
  updateClientId: (clientId: number) => void;
  refetchClient: () => Promise<unknown>;
};

export const ClientOnboardingContext =
  createContext<ClientOnboardingContextValue>({
    client: null,
    close: () => {},
    updateClientId: () => {},
    refetchClient: async () => {},
  });

export function useClientOnboarding() {
  const context = useContext(ClientOnboardingContext);
  if (!context) {
    throw new Error(
      "useClientOnboarding must be used within a ClientOnboardingContext.Provider"
    );
  }
  return context;
}
